export default __webpack_public_path__ + "static/social-skin-027fc449ac4aeb79950d8bee738b1bd9.webp";